import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../assets/img/icons/shopping-cart.svg'


const _hoisted_1 = { class: "row pt-100" }
const _hoisted_2 = { class: "col-xxl-9 col-xl-8" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "product-card" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_7 = { class: "product-info" }
const _hoisted_8 = { class: "fs-18 lh-1" }
const _hoisted_9 = { class: "text-center mt-2" }
const _hoisted_10 = {
  key: 0,
  class: "alert alert-success mt-3"
}
const _hoisted_11 = { class: "col-xxl-3 col-xl-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ShopSidebar = _resolveComponent("ShopSidebar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsLoaded, (product) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-xxl-4 col-xl-6 col-lg-4 col-md-6",
            key: product.id
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, { to: "/shop-details" }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    src: product.image,
                    alt: "Image"
                  }, null, 8, _hoisted_5)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h3", _hoisted_8, [
                    _createVNode(_component_router_link, { to: "/shop-details" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(product.title), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _createElementVNode("span", null, "$" + _toDisplayString(product.price), 1)
                ]),
                _createVNode(_component_router_link, {
                  to: "/cart",
                  class: "add-to-cart d-flex flex-column justify-content-center align-items-center transition bg-white"
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: "Image"
                    }, null, -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args))),
          class: "btn style-one"
        }, " Load More Products "),
        (_ctx.showAlert)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.alertMessage), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_ShopSidebar)
    ])
  ]))
}